<template lang="pug">
        ul(v-if="Companies && Companies.length > 1")
            li
                h4 Companies
            li(v-if='showAllLinks')
                router-link(:to="{ query: { ...$route.query, company_id: null, page: 1 } }") All companies
            li(v-for="company in Companies")
                router-link(:to="{ query: { ...$route.query, company_id: company.id, page: 1 } }")   {{ company.name }}
</template>

<script>
import UserCompaniesQuery from "@/graphql/queries/UserCompanies.js";

export default {
	name: "CompanyFilters",
	props: {
		showAllLinks: {
			type: Boolean,
			default: true
		}
	},
	apollo: {
		Companies: {
			query: UserCompaniesQuery,
			update: r => r.User.Companies
		}
	}
};
</script>
